// PortOneIdentityCallback.jsx
import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

export default function PortOneIdentityCallback() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const mode = searchParams.get("mode") || "default";
    const identityVerificationId = searchParams.get("identityVerificationId");

    if (!identityVerificationId) {
      alert("본인인증 정보가 올바르지 않습니다.");
      navigate("/");
      return;
    }

    (async () => {
      try {
        // 서버 검증 (PhoneIdentityVerification과 동일)
        const result = await fetch(
          process.env.REACT_APP_API_BASE + "/knouComm/api/identity-verifications", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ identityVerificationId }),
          }
        );

        if (!result.ok) {
          const errorText = await result.text();
          throw new Error("서버 검증 실패: " + errorText);
        }

        const verified = await result.json();

        // mode 별 분기
        // Step3 용 – 회원가입 플로우로 되돌아가서 처리
        if (mode === "signup") {
          localStorage.setItem("PortOne.Signup.verified", JSON.stringify(verified));
          navigate("/signup", { state: { fromPortone: true } });
        }
        // 휴면해제 용 – InactivityPhone 플로우로 되돌리기
        else if (mode === "inactivity") {
          localStorage.setItem("PortOne.Inactivity.verified", JSON.stringify(verified));
          navigate("/inactivity/phone", { state: { fromPortone: true } });
        }
        else {
          // 기타
          alert("처리할 수 없는 본인인증 요청입니다.");
          navigate("/");
        }
      } catch (e) {
        //console.error(e);
        alert("본인인증 결과 확인 중 오류가 발생했습니다.");
        navigate("/");
      }
    })();
  }, [navigate, searchParams]);

  return null; // 필요하면 로딩 스피너 표시
}
